export const enum STEPS {
    CHOOSE_STORE,
    DATE_AND_HOUR,
    CONTACT_INFORMATION,
    VERIFICATION,
    CONFIRMATION,
}
